<template>
  <a-modal v-model:visible="voteVisible" title="详情" :footer="null">
    <div>
      <div v-if="langList.length" class="mb20">
        <a-tabs
          v-model:activeKey="langCode"
          @change="() => changeLang(langCode)"
        >
          <a-tab-pane
            v-for="item in langList"
            :key="item.value"
            :tab="item.label"
          ></a-tab-pane>
        </a-tabs>
      </div>
      <div>
        <a-form
          v-for="item in postParams.langs"
          :key="item.langCode"
          ref="formRef"
          v-show="item.langCode === langCode"
          :model="formState"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          style="margin-bottom: 24px;"
        >
          <a-row>
            <a-col :span="22">
              <a-form-item label="投票名称" required>
                <a-input v-model:value="item.name" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="22">
              <a-form-item label="主标题" required>
                <a-input v-model:value="item.title" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="22">
              <a-form-item label="子标题" required>
                <a-input v-model:value="item.subTitle" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="22">
              <a-form-item label="banner链接">
                <a-input v-model:value="item.bannerUrl" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="22">
              <a-form-item label="状态" required>
                <a-switch
                  :disabled="item.langCode !== defaultLangCode"
                  v-model:checked="postParams.status"
                  checked-children="开"
                  un-checked-children="关"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" :offset="10" style="text-align: right;">
              <a-space>
                <a-button @click="() => voteVisibleChange(false)"
                  >返回</a-button
                >
                <a-button type="primary" @click="() => poll_save()"
                  >保存</a-button
                >
              </a-space>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      dragIcon:
        'https://cdn-image.kapeixi.cn/web/42debfc3-7cc4-4563-97cf-463a8c07d271/drag.png',
      mixDetailColumns: [
        {
          title: '优先级',
          dataIndex: 'priority',
          key: 'priority',
          align: 'center'
        },
        {
          title: 'collection ID',
          dataIndex: 'colId',
          key: 'colId',
          align: 'center'
        },
        {
          title: '穿插个数',
          dataIndex: 'crossNum',
          key: 'crossNum',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'deal',
          key: 'deal',
          align: 'center',
          width: 200,
          fixed: 'right'
        }
      ],
      mixColumns: [
        {
          title: 'mixId',
          dataIndex: 'colId',
          key: 'colId',
          align: 'center'
        },
        {
          title: '标题',
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: '最近修改人',
          dataIndex: 'updatorName',
          key: 'updatorName',
          align: 'center'
        },
        {
          title: '最近修改时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'deal',
          key: 'deal',
          align: 'center'
        }
      ]
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.red {
  color: red;
}
</style>
